// @ts-nocheck

import { Container } from "components/LandingPage/Container";

import {
  AcademicCapIcon,
  BadgeCheckIcon,
  CashIcon,
  ClockIcon,
  ReceiptRefundIcon,
  UsersIcon,
} from "@heroicons/react/outline";
import cx from "classix";
import { Glow, GlowCapture } from "@codaworks/react-glow";

const useCases = [
  {
    name: "Rapid Prototyping",
    description:
      "Build and test your ideas quickly without database setup. Store user data, configurations, and application state with instant persistence.",
    bgColor: "bg-primary-500",
  },
  {
    name: "Content Management",
    description: "Create dynamic websites and applications. Store blog posts, product catalogs, user-generated content, and configuration data.",
    bgColor: "bg-primary-500",
  },
  {
    name: "IoT Data Collection",
    description: "Collect and store sensor data from IoT devices. Real-time data ingestion with automatic versioning and analytics tracking.",
    bgColor: "bg-secondary-500",
  },
  {
    name: "Application Dashboards",
    description: "Build powerful dashboards and admin panels. Store metrics, user data, and application state for real-time monitoring and management.",
    bgColor: "bg-secondary-500",
  },
];

export function UseCases() {
  return (
    <section id="use-cases" className="">
      <Container className="max-w-7xl">
        <div className="flex justify-center">
          <h2 className="gradient-text font-bold text-4xl text-center">Perfect for any project</h2>
        </div>
        <div className="py-24 sm:py-32">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto grid max-w-2xl grid-cols-1 gap-8 overflow-hidden lg:mx-0 lg:max-w-none lg:grid-cols-4">
              {useCases.map((uc) => (
                <div
                  key={uc.name}
                  className="p-6 bg-[#C8C8C8]/5 rounded-[20px] border-[#5E5176] border hover:border-purple transition-all duration-200"
                >
                  <p className="text-lg font-semibold leading-8 tracking-tight text-gray-100">
                    {uc.name}
                  </p>
                  <p className="mt-3 text-base text-gray-300">
                    {uc.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}

function UseCaseCard({
  title,
  description,
  className,
}: {
  title: string;
  description: string;
  className?: string;
}) {
  return (
    <div
      className={cx(
        "border-[1px] border-[#5E5176] bg-[#C8C8C8]/5 rounded-[20px] w-full",
        className
      )}
    >
      <Glow className="">
        <div className="glow:text-glow/50 glow:bg-purple/10 px-16 py-12 h-full">
          <span className="text-4xl text-white">{title}</span>
          <p className="text-[#C4C4C4] mt-4 h-full">{description}</p>
        </div>
      </Glow>
    </div>
  );
}
